function isGuid(str: string): boolean {
    const guidRegex = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$");
    return guidRegex.test(str);
  }


export default isGuid;
